import * as echarts from 'echarts';
import dayjs from "dayjs";
import { getChartOption } from "./options.js"



/*********************************************************************************************************
 * 类：图表控制器
 *********************************************************************************************************/
export class ChartController {
  constructor(dom, type, time) {
    this.dom = dom;
    this.renderType = type; // 渲染类型：month-渲染一个月的数据 day-渲染一天的数据
    this.time = time; // 所选时间范围-1日or1月

    this.self = null; // 引用图表实例
    // debugger
    this.init();
  }


/** ====== [业务：初始化方法] =================================================================== */

  init() {
    // 初始化图表实例
    this.self = echarts.init(this.dom);

    // 初始化渲染：渲染空数据图表 >>> 组件数据更新后，会调用相关方法，更新渲染
    this.executeRender();

    // 监听浏览器尺寸变化，重置图表尺寸
    window.addEventListener('resize', () => {
      if (this.self) {
        this.self.resize();
      }
    })

  }

  updateTime(type, time) {
    this.renderType = type;
    this.time = time;
  }


/** ====== [业务：功能方法] =================================================================== */
  /**
   * 执行渲染
   * >>> 清空画布，然后渲染新数据
   * @param {*} lines 
   */
  executeRender(lines = []) {
    if (this.renderType === 'day') {
      const params = {
        startTime: dayjs(this.time).startOf('day').format('YYYY-MM-DD HH:mm:ss'),
        endTime: dayjs(this.time).endOf('day').format('YYYY-MM-DD HH:mm:ss'),
        timeType: this.renderType,
        lines,
      }
      console.log('BBBBBBB',params)
      const options = getChartOption(params);
      // 将配置对象设置给eChart进行渲染
      this.self.clear();
      this.self.setOption(options);

    } else if (this.renderType === 'month') {
      const params = {
        startTime: dayjs(this.time).startOf('month').format('YYYY-MM-DD HH:mm:ss'),
        endTime: dayjs(this.time).endOf('month').format('YYYY-MM-DD HH:mm:ss'),
        timeType: this.renderType,
        lines,
      }
      const options = getChartOption(params);
      // 将配置对象设置给eChart进行渲染
      this.self.clear();
      this.self.setOption(options);

    } else {
      console.error('渲染类型异常，请检查！')
    }
  }


  /**
   * 调整渲染
   * >>> 基于当前渲染结果，调整需要渲染的内容或效果
   * @param {*} param0 
   */
  adjustRender({}) {

  }








/** ====== [辅助：功能方法] =================================================================== */



}








